import "../PageLoader.css";

const PageLoader = () => {
  return (
    <div className="page-loader">
      <div className="loader">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <h2>Loading...</h2>
    </div>
  );
};

export default PageLoader;